<template>
  <div v-if="restrictedLineItems && reservationRequired">
    <div class="alert" :class="noTimesAvailable ? 'alert-danger' : 'alert-warning'" role="alert">
      <strong>
        {{
          noTimesAvailable
            ? 'There are no time slots available because of the following items:'
            : 'There are times not being shown because of the following items:'
        }}
      </strong>
    </div>

    <div
      v-for="(restrictedLine, scheduleName) in restrictedLineItems"
      :key="scheduleName"
      class="card mb-3"
      :class="noTimesAvailable ? 'border-danger' : 'border-warning'"
    >
      <div
        class="card-header d-flex align-items-center justify-content-between"
        :class="noTimesAvailable ? 'alert-danger' : 'alert-warning'"
      >
        <span>{{ $t('unavailable') }} - {{ scheduleName }}</span>
        <button
          v-if="restrictedLine.length > 1"
          class="btn btn-link underline-link-from-center"
          @click="$emit('removeallitems', { scheduleName, restrictedLineItems })"
        >
          <font-awesome-icon icon="trash" />
          {{ $t('removeAll') }}
        </button>
      </div>
      <div class="card-body">
        <div
          class="time-restricted-item mb-2"
          v-for="lineItem in restrictedLine"
          :key="lineItem.id"
        >
          <div class="d-flex align-items-center">
            <div class="img-thumbnail__wrapper">
              <WCImage
                :imageSrc="getProductImage(lineItem.item.image)"
                :imageAlt="productImgAltText(lineItem.item.name, lineItem.item.brand)"
                imageClass="img-thumbnail"
                defaultClass="wc-icon-wrapper mx-auto font-size-5x"
                :defaultTitle="noProductImageAltText(lineItem.item.name)"
              />
            </div>

            <a
              class="time-restricted-item-name underline-link-from-center"
              :href="`i/${lineItem.item.id}`"
              >{{ lineItem.item.name }}</a
            >
          </div>

          <button
            class="btn btn-link underline-link-from-center"
            @click="$emit('removeitem', lineItem)"
          >
            <font-awesome-icon icon="trash" />
            {{ $t('remove') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WCImage from '@/components/WCImage/WCImage.vue';
import ProductImageInfoMixin from '../../../../mixins/ProductImageInfoMixin';

export default {
  components: { WCImage },
  props: {
    shippingMethod: {
      type: Object,
    },
    reservationDates: {
      type: Array,
    },
    lineItems: {
      type: Array,
    },
    reservationRequired: {
      type: Boolean,
    },
  },
  mixins: [ProductImageInfoMixin],
  computed: {
    noTimesAvailable() {
      return this.reservationDates && this.reservationDates.length === 0;
    },
    restrictedLineItems() {
      let timeRestrictions = null;

      this.lineItems.forEach(lineItem => {
        if (lineItem.item && lineItem.item.prohibitedSalesScheduleNames) {
          const scheduleName = lineItem.item.prohibitedSalesScheduleNames.join(', ');

          if (!timeRestrictions) {
            timeRestrictions = {};
          }

          if (!timeRestrictions[scheduleName]) {
            timeRestrictions[scheduleName] = [];
          }

          timeRestrictions[scheduleName].push(lineItem);
        }
      });

      return timeRestrictions;
    },
  },
};
</script>

<style lang="scss" scoped>
.time-restricted-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
